var _g, _line, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 84,
    viewBox: "0 0 76 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_150)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 8.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 53,
    x2: 60,
    y2: 53,
    stroke: "white",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8 47.432C46.096 47.432 45.584 47.288 45.264 47C44.976 46.712 44.8 46.264 44.736 45.656L44.928 43.256C44.608 43.768 44.112 44.36 43.44 45.032C42.768 45.672 41.888 46.248 40.8 46.76C39.712 47.24 38.384 47.48 36.816 47.48C35.28 47.48 33.84 47.176 32.496 46.568C31.184 45.96 30.016 45.112 28.992 44.024C28 42.936 27.216 41.688 26.64 40.28C26.096 38.872 25.824 37.368 25.824 35.768C25.824 34.2 26.096 32.728 26.64 31.352C27.216 29.944 28.016 28.712 29.04 27.656C30.064 26.6 31.232 25.768 32.544 25.16C33.888 24.552 35.312 24.248 36.816 24.248C38.224 24.248 39.424 24.44 40.416 24.824C41.408 25.176 42.256 25.656 42.96 26.264C43.696 26.84 44.336 27.496 44.88 28.232L44.784 26.216C44.752 25.512 44.896 25.016 45.216 24.728C45.568 24.408 46.112 24.248 46.848 24.248C47.456 24.248 47.888 24.344 48.144 24.536C48.432 24.728 48.624 25 48.72 25.352C48.816 25.704 48.864 26.136 48.864 26.648V45.176C48.864 45.624 48.816 46.024 48.72 46.376C48.624 46.728 48.432 46.984 48.144 47.144C47.856 47.336 47.408 47.432 46.8 47.432ZM37.536 43.448C38.816 43.448 39.984 43.112 41.04 42.44C42.128 41.768 42.976 40.872 43.584 39.752C44.224 38.6 44.544 37.288 44.544 35.816C44.544 34.312 44.208 33 43.536 31.88C42.896 30.728 42.032 29.832 40.944 29.192C39.888 28.52 38.72 28.184 37.44 28.184C35.936 28.184 34.624 28.536 33.504 29.24C32.416 29.912 31.552 30.824 30.912 31.976C30.272 33.128 29.952 34.44 29.952 35.912C29.952 37.352 30.272 38.648 30.912 39.8C31.552 40.92 32.432 41.816 33.552 42.488C34.704 43.128 36.032 43.448 37.536 43.448Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_150",
    x: 0,
    y: 8,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_150",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpell);
export default __webpack_public_path__ + "static/media/spell.d75a19ed46dd3cdff10b1c1ba5bc5b92.svg";
export { ForwardRef as ReactComponent };